export default __webpack_public_path__ + "static/media/ORGANIC RECIPE.d4f54986.jpg";